module.exports = __webpack_public_path__ + "static/media/up.60eab0cd.svg";